export const FETCH_INITIAL_DATA_FOR_ADMIN_TAX_ENTRY_MODAL = 'FETCH_INITIAL_DATA_FOR_ADMIN_TAX_ENTRY_MODAL';
export const FETCH_INITIAL_DATA_FOR_ADMIN_TAX_ENTRY_MODAL_SUCCESS = 'FETCH_INITIAL_DATA_FOR_ADMIN_TAX_ENTRY_MODAL_SUCCESS';
export const FETCH_INITIAL_DATA_FOR_ADMIN_TAX_ENTRY_MODAL_FAILURE = 'FETCH_INITIAL_DATA_FOR_ADMIN_TAX_ENTRY_MODAL_FAILURE';
